<template>
  <div class="cloud-message-packets-component">
    <div class="column is-12">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
            Valores Atendimentos
          </p>
        </div>
      </div>
      <div class="columns mt-6 is-multiline">
        <div
            class="column is-half-desktop is-full-mobile is-full-tablet"
            v-for="(messagePacket, index) in formData.plan.data.messagePackets"
            :key="index"
        >
          <div
              class="is-flex is-justify-content-center is-full"
          >
            <div
                class="box is-size-3 mx-4 p-6 py-4-mobile px-3-mobile has-text-centered is-fullwidth"
            >
              <div class="columns">
                <div class="column is-12">
                  <h1 class="is-size-2 is-size-3-mobile has-text-weight-bold">
                    <span>
                      CLOUD
                    </span>
                  </h1>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full is-flex is-justify-content-center">
                  <div class="is-fit-width">
                    <div class="columns">
                      <div>
                        <div class="column pb-0 is-flex is-justify-content-center">
                          <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                          <span class="is-size-2 is-size-3-mobile has-text-weight-semibold has-text-black">
                            {{ formatPrice(messagePacket.price) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span class="tag is-primary is-small is-size-7-mobile">
                    POR ATENDIMENTO TIPO AUTENTICAÇÃO (INICIADO)
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column pb-0 is-flex is-justify-content-center">
                  <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                  <span class="is-size-2 is-size-3-mobile has-text-weight-semibold has-text-black">
                    {{ formatPrice(messagePacket.active_price) }}
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span class="tag is-primary is-small is-size-7-mobile">
                    POR ATENDIMENTO TIPO MARKETING (INICIADO) 
                  </span>
                </div>
              </div>
              
              <div class="columns">
                <div class="column pb-0 is-flex is-justify-content-center">
                  <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                  <span class="is-size-2 is-size-3-mobile has-text-weight-semibold has-text-black">
                    {{ formatPrice(messagePacket.utility_price)}}
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span class="tag is-primary is-small is-size-7-mobile">
                    POR ATENDIMENTO TIPO UTILIDADES (INICIADO)
                  </span>
                </div>
              </div>

              <div class="columns">
                <div class="column pb-0 is-flex is-justify-content-center">
                  <span class="has-text-grey-dark is-size-6 is-desktop is-pulled-left">R$</span>
                  <span class="is-size-2 is-size-3-mobile has-text-weight-semibold has-text-black">
                    {{ formatPrice(messagePacket.service_price)}}
                  </span>
                </div>
              </div>
              <div class="columns">
                <div class="column is-full">
                  <span class="tag is-primary is-small is-size-7-mobile">
                    POR ATENDIMENTO SERVIÇO (RECEBIDO)
                  </span>
                </div>
              </div>

              <div class="columns">
                <div class="column is-full">
                  <button
                      class="button is-primary is-size-5 is-size-6-mobile is-medium has-text-weight-medium is-four-fifths"
                      @click.prevent="chooseMessagePacket(messagePacket)"
                  >
                    <div class="is-fullwidth">
                      Continuar
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half-desktop is-full-mobile is-full-tablet">
          <div class="buttons is-flex is-justify-content-center is-full">
            <span class="is-size-4 is-size-5-mobile has-text-centered has-text-grey-dark has-text-weight-bold dm-sans mb-4">
              Informações importantes
            </span>
          </div>
          <div
              class="is-flex is-justify-content-center is-full"
          >
            <table class="table mobile-friendly-table">
              <tbody>
              <tr>
                <td class="is-relative">
                  <div class="center-blocked-element">
                    <font-awesome-icon
                        icon="fa-regular fa-circle"
                        color="black"
                        size="1x"
                    />
                  </div>
                </td>
                <td class="is-flex is-justify-content-start is-align-content-center ml-2">
                  <span class="info-text">
                    <strong>
                      Os valores de mensalidade e implantação são pagos antes do uso, os atendimentos são pagos depois do uso;
                    </strong>
                  </span>
                </td>
              </tr>
              <tr>
                <td class="is-relative">
                  <div class="center-blocked-element">
                    <font-awesome-icon
                        icon="fa-regular fa-circle"
                        color="black"
                        size="1x"
                    />
                  </div>
                </td>
                <td class="is-flex is-justify-content-start is-align-content-center ml-2">
                  <span class="info-text"><strong>Um atendimento tem duração de 24 horas após primeira mensagem;</strong></span>
                </td>
              </tr>
              <tr>
                <td class="is-relative">
                  <div class="center-blocked-element">
                    <font-awesome-icon
                        icon="fa-regular fa-circle"
                        color="black"
                        size="1x"
                    />
                  </div>
                </td>
                <td class="is-flex is-justify-content-start is-align-content-center ml-2">
                  <span class="info-text">
                    <strong>
                      Os valores e condições são referentes as políticas da Meta.inc (WhatsApp), podendo ocorrer mudanças.
                    </strong>
                  </span>
                </td>
              </tr>
              <tr>
                <td class="is-relative">
                  <div class="center-blocked-element">
                    <font-awesome-icon
                        icon="fa-regular fa-circle"
                        color="black"
                        size="1x"
                    />
                  </div>
                </td>
                <td class="is-flex is-justify-content-start is-align-content-center ml-2">
                  <span class="info-text">
                    <strong>
                      Atendimento iniciado é quando a empresa envia a primeira mensagem, e atendimento recebido é quando o cliente inicia o contato. 
                    </strong>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6">
      <div class="columns">
        <div class="column is-full is-flex is-justify-content-start is-align-content-start">
          <button
              class="button is-primary is-size-4 is-size-6-mobile is-large has-text-weight-medium mobile-back-btn"
              @click.prevent="$emit('previousTab')"
          >
            <div class="is-flex is-align-items-center">
              <span class="icon-text pr-2">
                <
              </span>
              <span v-if="isMobile" class="mobile-btn-text">Voltar</span>
              <span v-else class="desktop-btn-text">Escolher outro plano</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'messagePackets',

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      isMobile: false
    }
  },

  methods: {

    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },

    chooseMessagePacket(messagePacket) {
      this.formData.messagePacket.hasSum = messagePacket.mode === 2
      this.formData.messagePacket.showStep = true
      this.formData.messagePacket.data = messagePacket
      this.formData.messagePacket.data.quantity = 1
      this.formData.messagePacket.data.originalPrice = messagePacket.price
      const appStore = useAppStore()
      appStore.showReviewNextButton = true

      // Abrir sidebar automaticamente no mobile
      if (window.innerWidth < 1024) { // 1024px é o breakpoint desktop do Bulma
        appStore.isMobileSidebarVisible = true;
      }
      
      // Rolar para a seção de resumo do plano
      this.scrollToPlanSummary();
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    },
    
    scrollToPlanSummary() {
      // Timeout para garantir que a DOM será atualizada primeiro
      setTimeout(() => {
        // Em dispositivos móveis, o resumo está na parte inferior da página
        if (window.innerWidth < 1024) {
          // Elemento de resumo no modo mobile
          const reviewElement = document.querySelector('.mobile-summary-container');
          if (reviewElement) {
            reviewElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            // Alternativa: rolar para o final da página
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth'
            });
          }
        } else {
          // Em desktop, o resumo está na sidebar à direita
          const sidebarElement = document.querySelector('.review-sidebar-component');
          if (sidebarElement) {
            const topPosition = sidebarElement.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: topPosition - 80, // Ajuste para considerar a navbar
              behavior: 'smooth'
            });
          }
        }
      }, 100);
    }

  },

  mounted() {
    const appStore = useAppStore()
    appStore.showReviewNextButton = false
    
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  }

}

</script>

<style lang="scss" scoped>
$box-color: #000;

.center-blocked-element {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.info-text {
  @media screen and (max-width: 768px) {
    font-size: 0.85rem;
  }
}

.mobile-friendly-table {
  @media screen and (max-width: 768px) {
    font-size: 0.85rem;
    width: 100%;
    padding: 0.5rem;
  }
}

@media screen and (max-width: 768px) {
  .tag.is-primary {
    white-space: normal;
    height: auto;
    padding: 0.25rem 0.5rem;
    line-height: 1.2;
  }
  
  .box {
    margin: 0.5rem !important;
    padding: 1rem !important;
  }
  
  .mobile-back-btn {
    padding: 0.5rem 1rem !important;
    height: auto !important;
    font-size: 0.9rem !important;
    width: auto !important;
    
    .icon-text {
      font-size: 1rem;
    }
  }
  
  @media screen and (max-width: 400px) {
    .mobile-back-btn {
      padding: 0.5rem !important;
      width: auto !important;
    }
  }
}

@media screen and (min-width: 769px) {
  .mobile-back-btn {
    width: auto;
    min-width: 200px;
  }
  
  .desktop-btn-text {
    font-size: 1rem;
  }
}
</style>